/**
 * @description Super Admin sidebar selection for reused `/tenants/{id}`
 *
 * Key features:
 * - TenantDetail publishes channelPartnerId so the sidebar can keep
 *   Channel Partners selected on under-CP click-into
 * - LynxPay detail publishes null — Sales Orgs stays selected
 *
 * @dependencies
 * - React context
 *
 * @notes
 * - Click-into stays on `/tenants/{salesOrgId}`; highlight is not the URL prefix
 * - Missing provider is a no-op so source-read tests do not need a wrapper
 * - Preferred names: channelPartnerId / salesOrgId
 */

import { createContext, useCallback, useContext, useMemo, useState } from 'react';

const AdminNavContext = createContext(null);

export function AdminNavProvider({ children }) {
  const [tenantChannelPartnerId, setTenantChannelPartnerIdState] = useState(undefined);

  const setTenantChannelPartnerId = useCallback((channelPartnerId) => {
    setTenantChannelPartnerIdState(channelPartnerId);
  }, []);

  const value = useMemo(() => ({
    tenantChannelPartnerId,
    setTenantChannelPartnerId
  }), [tenantChannelPartnerId, setTenantChannelPartnerId]);

  return (
    <AdminNavContext.Provider value={value}>
      {children}
    </AdminNavContext.Provider>
  );
}

export function useAdminNav() {
  return useContext(AdminNavContext) || {
    tenantChannelPartnerId: undefined,
    setTenantChannelPartnerId: () => {}
  };
}

export default AdminNavContext;
